import { APIForm } from './_api-form.js';
class UpdateForm extends APIForm {
  constructor() {
    super();
    this._successModalId = null;
    this._deleteButton = null;
    this._deleteAccountButton = null;
    this._siteUrl = null;
    this._deleteEndpoint = null;
    this._countryField = null;
    this._regionField = null;
  }
  connectedCallback() {
    super.connectedCallback();
    this._successModalId = this.getAttribute('data-success');
    this._siteUrl = this.getAttribute('data-site-url');
    this._deleteEndpoint = this.getAttribute('data-delete-endpoint');
    this._deleteButton = this.querySelector('[data-action="delete"]');
    if (this._deleteButton) {
      this._setupDeleteButtonHandler();
    }
    this._deleteAccountButton = document.querySelector('[data-action="delete-account"]');
    if (this._deleteAccountButton) {
      this._setupDeleteAccountHandler();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._deleteButton) {
      this._deleteButton.removeEventListener('click', this._handleDeleteClick);
    }
    if (this._deleteAccountButton) {
      this._deleteAccountButton.removeEventListener('click', this._handleDeleteAccountClick);
    }
  }
  _getDefaultEndpoint() {
    return "/wp-json/api/v1/ambassador/update";
  }
  _setupDeleteButtonHandler() {
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._deleteButton.addEventListener('click', this._handleDeleteClick);
  }
  _handleDeleteClick(event) {
    event.preventDefault();
    // Get the modal ID from aria-controls attribute
    const modalId = this._deleteButton.getAttribute('aria-controls');
    if (!modalId) return;
    // Find the modal element
    const modalElement = document.getElementById(modalId);
    if (!modalElement) return;
    // Get the custom element instance
    const modalComponent = modalElement.closest('modal-dialog') || modalElement;
    if (!modalComponent) return;
    // Set aria-expanded attribute to true when opening
    this._deleteButton.setAttribute('aria-expanded', 'true');
    // Open the modal
    if (typeof modalComponent.open === 'function') {
      modalComponent.open();
    }
    // Listen for modal close to update aria-expanded
    const handleModalClose = () => {
      this._deleteButton.setAttribute('aria-expanded', 'false');
      modalComponent.removeEventListener('modal:closed', handleModalClose);
    };
    modalComponent.addEventListener('modal:closed', handleModalClose);
  }
  _setupDeleteAccountHandler() {
    this._handleDeleteAccountClick = this._handleDeleteAccountClick.bind(this);
    this._deleteAccountButton.addEventListener('click', this._handleDeleteAccountClick);
  }
  _handleDeleteAccountClick() {
    // Get the nonce from the data attribute
    const nonce = this.getAttribute('data-nonce');
    fetch(this._deleteEndpoint, {
      method: "POST",
      headers: {
        "X-WP-Nonce": nonce,
        "Content-Type": "application/json"
      },
      credentials: "include"
    }).then(response => {
      if (response.ok) {
        // Redirect to homepage after successful deletion
        window.location.href = this._siteUrl || '/';
        return;
      }
      throw new Error('Network response was not ok');
    }).catch(error => {
      // Optionally show an error message
      console.error('Account deletion failed:', error);
    });
  }
}
customElements.define('update-form', UpdateForm);